import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { faEye, faEyeSlash, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TenantService } from '../../services/tenant.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, FontAwesomeModule, TranslateModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  faEye = faEye;
  faEyeSlash = faEyeSlash;
  faSpinner = faSpinner;
  username = '';
  password = '';
  error = '';
  loading = false;
  year = new Date().getFullYear();

  logoSrc = 'assets/logo/delfos_logo_and_text.png';

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private tenantService: TenantService
  ) {}

  ngOnInit(): void {
    const slug = this.route.snapshot.paramMap.get('slug') || '';
    if (slug) {
      this.tenantService.resolve(slug).subscribe();
    } else {
      this.tenantService.loadTenants().subscribe(() => {
        this.tenantService.setDefault();
      });
    }

    this.tenantService.tenant$.subscribe(tenant => {
      if (tenant) {
        this.logoSrc = tenant.logoFull || 'assets/logo/delfos_logo_and_text.png';
      }
    });
  }

  login() {
    this.error = '';
    this.loading = true;
    
    const endpoint = '/api/auth/login';
    
    this.http.post<{ token: string, role: string, email: string }>(endpoint, {
      email: this.username,
      password: this.password
    }).subscribe({
      next: res => {
        sessionStorage.setItem('token', res.token);
        sessionStorage.setItem('role', res.role);
        sessionStorage.setItem('email', res.email);
        this.loading = false;
        const route = this.tenantService.buildRoute('/simulations');
        this.router.navigate(route);
      },
      error: err => {
        this.loading = false;
        if (err.error && err.error.detail) {
          this.error = err.error.detail;
        } else if (err.status === 401) {
          this.error = this.translate.instant('LOGIN.INVALID_CREDENTIALS');
        } else {
          this.error = this.translate.instant('LOGIN.SERVER_ERROR');
        }
      }
    });
  }

  showPassword = false;

  togglePassword() {
    this.showPassword = !this.showPassword;
    const passwordInput = document.getElementById('password') as HTMLInputElement;
    if (passwordInput) {
      passwordInput.type = this.showPassword ? 'text' : 'password';
    }
  }
}